module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Area Nutrizionisti","pageMetaDescription":"Area Nutrizionisti","mypatients":"I Miei Pazienti","mybookings":"I Miei Appuntamenti","GoogleCalendarConnect":"Google Calendar Connect","calendar":"Calendario"}}')
  delete Component.options._Ctor
}
